
const monthPriceConfig: number = 24;
const monthPriceConfigFake: number = 49;

export default {
  monthPriceConfig,
  monthPriceConfigFake
};
